import { render, staticRenderFns } from "./PreciseMoreContent.vue?vue&type=template&id=76ec5750&scoped=true"
import script from "./PreciseMoreContent.vue?vue&type=script&lang=js"
export * from "./PreciseMoreContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec5750",
  null
  
)

export default component.exports